import { defineStore } from 'pinia'
import axiosInstance, { post_login, logout, get_user } from '../axios'
import { jwtDecode, JwtPayload } from 'jwt-decode'

import { useToast } from 'vuestic-ui'

const { init } = useToast()

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as {
      email: string
      id: string
      is_active: boolean
      is_superuser: boolean
      is_verified: boolean
      is_ro: boolean
      is_dashboard_only: boolean
      ireboxes?: string[]
    } | null,
    expirationTime: null as number | null | undefined,
  }),
  actions: {
    async initializeAuth() {
      const res_user = await get_user()
      if (res_user.status === 401) {
        await this.logout()
        return
      }
      if (res_user && 'data' in res_user && res_user.status !== 401) {
        this.user = res_user.data
        const _expirationTime = parseInt(localStorage.getItem('expirationTime') || '0')

        if (this.isAuthenticated() && _expirationTime) {
          const currentTime = new Date().getTime()
          if (currentTime < _expirationTime) {
            this.expirationTime = _expirationTime
          } else {
            await this.logout()
          }
        } else {
          await this.logout()
        }
      } else {
        await this.logout()
      }
    },
    async login(credentials: { email: string; password: string; keepLoggedIn: boolean }) {
      const response = await post_login(credentials)

      // Overenie, či je 'response' typu AxiosResponse a obsahuje 'data'
      if (response && 'data' in response && response.status === 200) {
        const decodedToken = jwtDecode<JwtPayload>(response.data.access_token)
        if (decodedToken.exp) {
          const expirationTime = decodedToken.exp * 1000
          localStorage.setItem('expirationTime', String(expirationTime))
        }

        localStorage.setItem('token', response.data.access_token)

        const res_user = await get_user()
        if (res_user && 'data' in res_user && res_user.status !== 401) {
          this.user = res_user.data
          this.expirationTime = parseInt(localStorage.getItem('expirationTime') || '0')
        } else {
          await this.logout()
        }
      }
    },
    async logout() {
      this.expirationTime = null
      await logout()
      delete axiosInstance.defaults.headers.common['Authorization']
      localStorage.removeItem('token')
      localStorage.removeItem('expirationTime')
      this.user = null
      this.expirationTime = null
    },
    async logoutUser() {
      this.expirationTime = null
      delete axiosInstance.defaults.headers.common['Authorization']
      localStorage.removeItem('token')
      localStorage.removeItem('expirationTime')
      this.user = null
      this.expirationTime = null
      init({
        message: 'Token expired, please log in again',
        color: 'danger',
      })
    },
    getToken() {
      return localStorage.getItem('token')
    },
    isAuthenticated() {
      return this.user !== null
    },
    isSuperUser() {
      return this.user?.is_superuser
    },
    isReadOnly() {
      return this.user?.is_ro
    },
    isDashboardOnly() {
      return this.user?.is_dashboard_only
    },
    get_user() {
      return this.user
    },
  },
})
